module.exports = __webpack_public_path__ + "img/_DSC5086.jpg";